import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'lineThrough' })
export class LineThroughPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(value: string): SafeHtml | string {
    if (!value) { return ''; }
    const reg = new RegExp(TrasmessoRegex, 'gi');
    return this.sanitizer.bypassSecurityTrustHtml(value.toString().replace(reg, `<span style='text-decoration: line-through;'>$1</span>`));
  }
}
export const TrasmessoRegex = '#(.*?)#';
